/*@ngInject*/
const UIFocusManagerDirective = function ($document, $timeout, coreConstant) {

    let linkFunction = function ($scope, $elm, $attrs) {

        $scope.$on(coreConstant.event.ADVANCE_FOCUS, function (event, selector, delayOverride) {
            let parentSelector = '.' + $attrs['uiFocusManager'] + ' ',
                focusElement,
                delay = delayOverride || 300;

            $timeout(function () {
                function isBody(element) {
                    return $document[0].body === element;
                }

                function isDescendant(parent, child) {
                    let node;

                    if (child) {
                        node = child.parentNode;
                        while (!_.isNull(node)) {
                            if (node === parent) {
                                return true;
                            }
                            node = node.parentNode;
                        }
                    }
                    return false;
                }

                focusElement = $(parentSelector + selector);

                // Limit focus change so that it occurs if the current focus is in the document body,
                // or if the current focus is a child of the parentSelector (element where
                // ui-focus-manager lives.)
                if (focusElement && (isBody($document[0].activeElement) || isDescendant($(parentSelector)[0], $document[0].activeElement))) {
                    focusElement.focus();

                    if (focusElement.hasClass('ui-select-match')) {
                        focusElement.click();
                    }
                }

            }, delay);
        });

    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiFocusManager', UIFocusManagerDirective);

